import Table from './Table';
import ButtonCell from './ButtonCell';
import InputCell from './InputCell';
import SelectCell from './SelectCell';
import CheckboxCell from './CheckboxCell';
Table.InputCell = InputCell;
Table.SelectCell = SelectCell;
Table.ButtonCell = ButtonCell;
Table.CheckboxCell = CheckboxCell;
export default Table;